<!-- Interpolation must be used in order to dynamically bind the placeholder and i18n-placeholder inputs -->
<mat-form-field appearance="fill" class="w-100" [attr.data-testId]="controlName ?? ''">
  <mat-label *ngIf="shouldDisplayLabel" i18n="{{localizationLabel}}">{{label}}</mat-label>
  <mat-select
    #select
    [formControl]="selectControl"
    class="searchableSelect"
    data-testId="searchable-select"
    [panelClass]="!disableVirtualization ?'virtualScroll_panel': ''"
    placeholder="{{placeholder}}"
    i18n-placeholder="{{localizationPlaceholder}}"
    [ngClass]="{'hideArrow': shouldHideArrow}"
    (openedChange)="onOpenedChanged($event)"
    (selectionChange)="onSelectionChanged($event)"
    [disabled]="isDisabled"
    [required]="isRequired"
  >
    <mat-select-trigger>
      <span
        *ngLet="(options | findByProperty : 'id' : selectControl?.value) as selectedItem"
        [attr.data-testId]="selectedItem?.name"
        class="d-flex align-items-center"
        [class.inactiveSelection]="shouldHideInactiveOptions && selectedItem?.isActive === false"
      >
        <mat-icon *ngIf="selectedItem?.icon" class="mr-2" [svgIcon]="selectedItem?.icon"></mat-icon>
        {{ selectedItem?.name }}
      </span>
    </mat-select-trigger>

    <mat-option>
      <ngx-mat-select-search
        data-testId="searchable-select"
        [formControl]="filterControl"
        [disableInitialFocus]="hasInitialFocusDisabled"
        [placeholderLabel]="StaticMessage.SearchLabel | staticMessage"
      >
        <mat-icon svgIcon="close" color="primary" ngxMatSelectSearchClear></mat-icon>
      </ngx-mat-select-search>
    </mat-option>

    <ng-container *ngLet="filteredOptions$ | async as filteredOptions">
      <ng-container *ngIf="!disableVirtualization; else noVirtualization">
        <cdk-virtual-scroll-viewport
          #virtualScroll
          minBufferPx="200"
          maxBufferPx="400"
          [style.height.px]="panelHeight"
          [itemSize]="optionSize"
        >
          <mat-option
            *ngIf="shouldIncludeNoneOption"
            [style.height.px]="optionSize"
            [value]="null"
            data-testId="none-option"
          >
            {{StaticMessage.NoneOptionName | staticMessage}}
          </mat-option>
          <mat-option
            #option
            *cdkVirtualFor="let option of filteredOptions; trackBy: trackByFunction"
            [attr.data-testId]="option.name"
            [style.height.px]="optionSize"
            [value]="option.id"
          >
            <span class="d-flex align-items-center">
              <mat-icon *ngIf="option?.icon" class="mr-2" [svgIcon]="option?.icon"></mat-icon>
              {{ option.name }}
            </span>
          </mat-option>

          <!--
            This is necessary in order to keep the selected value
            https://github.com/angular/components/issues/10122
          -->
          <mat-option class="d-none" [value]="selectControl.value"></mat-option>
        </cdk-virtual-scroll-viewport>
      </ng-container>

      <ng-template #noVirtualization>
        <mat-option
          *ngIf="shouldIncludeNoneOption"
          [style.height.px]="optionSize"
          [value]="null"
          data-testId="none-option"
        >
          {{StaticMessage.NoneOptionName | staticMessage}}
        </mat-option>
        <mat-option
          *ngFor="let option of filteredOptions; trackBy: trackByFunction"
          [attr.data-testId]="option.name"
          [style.height.px]="optionSize"
          [value]="option.id"
        >
          <span class="d-flex align-items-center">
            <mat-icon *ngIf="option?.icon" class="mr-2" [svgIcon]="option?.icon"></mat-icon>
            {{ option.name }}
          </span>
        </mat-option>

        <!--
          This is necessary in order to keep the selected value
          https://github.com/angular/components/issues/10122
        -->
        <mat-option class="d-none" [value]="selectControl.value"></mat-option>
      </ng-template>

      <mat-option *ngIf="filteredOptions.length === 0" disabled>
        {{StaticMessage.NoSearchResultsLabel | staticMessage}}
      </mat-option>
    </ng-container>
  </mat-select>
  <mat-error *ngIf="selectControl.errors?.required">{{errorMessage}}</mat-error>
  <mat-hint class="mat-hint" *ngIf="hintMessage">{{hintMessage}}</mat-hint>
</mat-form-field>
